import React, { useRef } from "react";
import {
  Box,
} from "@mui/material";
import Wsp from "../../../contact/Component/Floatingwsp";

import {
  BannerData,
  caroData,
  CircleData,
  DetailInfo,
  TrimData,
  caro3in1Data,
  gridData,
  com3struct,
  Caro3Heading
} from "./Data";
import Banner from "../../../../Common/Components/Banner";
import Caro from "../../../../Common/Components/Caro";
import CarModel from "../../../../Common/Components/CarModel";
import ShowInterest from "../../../../Common/Container/showintrestCon";
import MeetTheFamily from "../../../../Common/Components/MeetTheFamily";
import DetailedInfo from "../../../../Common/Components/DetailedInfo";
import Caro3in1 from "../../../../Common/Components/3in1caro";
import Gridview from "../../../../Common/Components/Gridview";
import EVShowcase from "../../../../Common/Components/ComEvstruct";

export default function Ev6() {
  const showInterestRef = useRef(null);
  return (
    <Box sx={{ overflowX: "hidden" }}>
      <Banner bannerData={BannerData} />
      <Caro trim={caroData} />
      <CarModel
        model="Ev6"
        bgCar={
          "https://firebasestorage.googleapis.com/v0/b/kiacentral-dcdd7.firebasestorage.app/o/Seltos%2Fint2.mp4?alt=media&token=4111ad1b-e446-42ad-855e-2f81601538a2"
        }
        CircleData={CircleData}
      />
      <Caro3in1 caro3in1Data={caro3in1Data} heading={Caro3Heading} />
      <div ref={showInterestRef}>
        <ShowInterest someValue="Ev6" />
      </div>
      <Gridview gridData={gridData} />
      <EVShowcase com3struct={com3struct} />
      <MeetTheFamily TrimData={TrimData} data={CircleData} />
      <DetailedInfo
        DetailInfo={DetailInfo}
        onScrollToInterest={() => {
          if (showInterestRef.current) {
            showInterestRef.current.scrollIntoView({ behavior: "smooth" });
          }
        }}
      />
      <Wsp />
    </Box>
  );
}
